import { Star, ExternalLink, PenLine } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { GoogleIcon } from "./Icons";

const ext = { target: "_blank", rel: "noopener noreferrer" };

const GoldStars = ({ value, size = "h-4 w-4" }) => {
  const v = parseFloat(String(value).replace(",", ".")) || 5;
  return (
    <span className="flex gap-0.5" aria-label={`${value} / 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`${size} ${i <= Math.round(v) ? "fill-gold text-gold" : "text-gold/30"}`} strokeWidth={1.5} />
      ))}
    </span>
  );
};

export const GoogleRating = ({ compact = false, dark = false, testId = "google-rating" }) => {
  const { settings: s } = useSite();
  if (compact) {
    return (
      <a href={s.google_reviews_url} {...ext} data-testid={testId} className={`group inline-flex items-center gap-3 rounded-2xl px-4 py-3 ring-1 transition-colors ${dark ? "bg-white/5 ring-gold/30 hover:ring-gold" : "bg-white ring-gold/25 hover:ring-gold/60"}`}>
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-sm"><GoogleIcon className="h-5 w-5" /></span>
        <span>
          <span className="flex items-center gap-2">
            <span className={`text-lg font-semibold ${dark ? "text-white" : "text-emerald-950"}`}>{s.google_rating}</span>
            <GoldStars value={s.google_rating} size="h-3.5 w-3.5" />
          </span>
          <span className={`block text-xs ${dark ? "text-white/60" : "text-ink/55"}`}>{s.google_review_count} Google Yorumu</span>
        </span>
      </a>
    );
  }
  return (
    <div className="card-lux flex flex-col gap-6 p-6 sm:flex-row sm:items-center sm:justify-between sm:p-8" data-testid={testId}>
      <div className="flex items-center gap-5">
        <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-white shadow-[0_8px_24px_-12px_rgba(2,44,34,0.35)] ring-1 ring-gold/25"><GoogleIcon className="h-9 w-9" /></span>
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-gold-deep">Google Puanı</p>
          <div className="mt-1 flex items-center gap-3">
            <span className="text-3xl font-bold text-emerald-950" data-testid={`${testId}-value`}>{s.google_rating}</span>
            <GoldStars value={s.google_rating} size="h-5 w-5" />
          </div>
          <p className="mt-0.5 text-sm text-ink/60" data-testid={`${testId}-count`}>{s.google_review_count} Google Yorumu</p>
        </div>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row">
        <a href={s.google_reviews_url} {...ext} className="btn-emerald !py-2.5" data-testid={`${testId}-all-btn`}><ExternalLink className="h-4 w-4" /> Google'da Tüm Yorumlar</a>
        <a href={s.google_write_url} {...ext} className="btn-outline !py-2.5" data-testid={`${testId}-write-btn`}><PenLine className="h-4 w-4" /> Yorum Yap</a>
      </div>
    </div>
  );
};
